import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkLoader } from 'uitk-react-loader';

import { AskAQuestion } from 'components/infosite/conversations';
import { AskAQuestionData } from './ask-a-question';
import { ConversationsOperationResult } from '__generated__/api';

export interface ConversationsProps {
  currentHotel?: CurrentHotelStore;
  show: boolean;
}

@inject('currentHotel')
@observer
export class Conversations extends React.Component<ConversationsProps> {
  public constructor(props) {
    super(props);
    this.handleCreateConversation = this.handleCreateConversation.bind(this);
    this.handleDismissResult = this.handleDismissResult.bind(this);
  }

  public componentDidMount() {
    const { currentHotel } = this.props;
    const propertyId = currentHotel && currentHotel.hotelId;
    currentHotel.fetchConversations(propertyId.toString());
  }

  public render() {
    const { currentHotel, show } = this.props;
    const { loadingConversations, creatingConversation, conversations } = currentHotel;
    const viewModel = conversations && conversations.viewModel;
    const newConversation = viewModel && viewModel.newConversation;
    const result = viewModel && viewModel.result;
    const alert = viewModel && viewModel.alert;
    const action = viewModel && viewModel.action;
    const askAQuestionProps = {
      ...newConversation,
      alert,
      success: result === ConversationsOperationResult.SUCCESS,
      action,
      loading: creatingConversation,
      onSubmit: this.handleCreateConversation
    };

    return (
      <React.Fragment>
        {show &&
          loadingConversations && (
            <div className="uitk-type-center">
              <UitkLoader />
            </div>
          )}
        {show && newConversation && <AskAQuestion {...askAQuestionProps} />}
      </React.Fragment>
    );
  }

  public handleCreateConversation(data: AskAQuestionData) {
    const { currentHotel } = this.props;
    const propertyId = currentHotel && currentHotel.hotelId;
    const searchCriteria = currentHotel && currentHotel.searchCriteria;
    const { name, question, email } = data;
    currentHotel.createConversation(question, propertyId.toString(), name, email, searchCriteria, window.location.href);
  }

  public handleDismissResult() {
    const { currentHotel } = this.props;
    currentHotel.clearCreateConversationResult();
  }
}
